// extracted by mini-css-extract-plugin
export default {"expertiseStyles":"Expertise_expertiseStyles__ZbOzh","images":"Expertise_images__dEKH-"};